import React,{useState,useEffect} from "react";
import {Link} from "react-router-dom";
import ImageWithBasePath from "../../../../../core/img";
import {all_routes} from "../../../../router/all_routes";
import Table from "../../../../../core/dataTable/non-pager/index";
import {Toaster} from 'react-hot-toast';
import {UrlQuery} from "biz9-react-utility";
// -- biz9 --
import {Str,DateTime} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {User_Logic,User_Table} from "biz9-user";
import {Message} from "../../../../../constant";
import {Image,Style,Storage,Toast_Message,App} from "../../../../../project";
import {Portal_Table,Portal_Type,Portal_Url,Portal_Remote_Store_Cart} from "biz9-portal-app";
import {Data_Logic} from "biz9-data-app";
const Dashboard_Admin_Cart_Detail = () => {
    const query = UrlQuery();
    const [val_cart_number,setValCartNumber] = useState(query.get('cart_number'));
    const [user,setUser] = useState(Data_Logic.get(Portal_Table.USER,0));
    const [cart,setCart] = useState(Data_Logic.get(Portal_Table.CART,0));
    const [cart_items,setCartItems] = useState([]);
    const [cart_sub_items,setCartSubItems] = useState([]);
    const cart_item_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.title}
                   </>
                   ),
           sorter: true
    },
    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               ),
       sorter: true
    },
    {
title: "Quanity",
       dataIndex: "quanity",
       render: (text: string, record: any) => (
               <>
               {record.quanity}
               </>
               ),
       sorter: true
    },
    ];
    const cart_sub_item_columns = [
    {
title: "Title",
           dataIndex: "title",
           render: (text: string, record: any) => (
                   <>
                   {record.parent.type}{" "}{record.parent.category}{" "}{record.parent.title}
                   </>
                   ),
           sorter: true
    },
    {
title: "Cost",
       dataIndex: "cost",
       render: (text: string, record: any) => (
               <>
               {Str.get_money(record.parent.cost)}
               </>
               ),
       sorter: true
    },
    {
title: "Quanity",
       dataIndex: "quanity",
       render: (text: string, record: any) => (
               <>
               {record.quanity}
               </>
               ),
       sorter: true
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            Storage.post_dashboard_side_bar(Portal_Table.CART);
            if(!Str.check_is_null(val_cart_number)){
            get_data();
            }
            },[val_cart_number]);
    async function get_data() {
        const [response,data] = await Portal_Remote_Store_Cart.get(App.get_url(Portal_Url.STORE_CART_GET),val_cart_number);
        console.log('11',data);
        bind_items(data);
       Toast_Message.dismiss();
    }
    async function bind_page(data) {
        //setValSubPageTitle('data.title');
    };
    async function bind_field(data) {
    }
    async function bind_items(data){
        setCart(data[Portal_Type.CART]);
        setCartItems(data[Portal_Type.CART].cart_items);
        let cart_item_sub_items = [];
        data[Portal_Type.CART].cart_items.forEach(cart_item => {
            cart_item_sub_items = cart_item_sub_items.concat(cart_item.cart_sub_items);
        });
        setCartSubItems(cart_item_sub_items);
    }
    return (
            <>
        <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="page-content content">
            <div className="row justify-content-center">
            <div className="col-xl-10">
            <div className="main-title mb-4">
            <h4>Cart Detail</h4>
            </div>
            <ul className="nav nav-tabs nav-tabs-bottom mb-4">
            <li className="nav-item">
            <Link to={all_routes.dashboard_admin_cart} className="nav-link" >
            {"<- " + Str.get_table_by_name(Portal_Table.CART,{plural:true})}
            </Link>
            </li>
            </ul>
            <div className="card profile-card">
            <div className="card-body">

            <div className="d-flex align-items-center gap-3 justify-content-between flex-wrap">
            <div className="d-flex align-items-center flex-shrink-0">
            <span className="avatar avatar-lg">
            <ImageWithBasePath className="rounded-2" src={Image.get_url(user.image_filename,Image_Format.SQUARE_THUMB,{table:Portal_Table.USER})}
    alt="img" />
        </span>
        <div className="ms-3">
        <h6 className="mb-1 d-inline-flex flex-wrap align-items-center">
        {user.title?user.title:"N/A"}
    </h6>
        <p className="mb-2">{user.email}</p>
        <p className="mb-2">{User_Logic.get_country_state_city(user)}</p>
        </div>
        </div>
        <Link to={all_routes.dashboard_admin_user_detail+"?id="+user.id} className="btn btn-lg btn-dark">
         Profile
        </Link>
        </div>
        </div>
        </div>

        <div className="card profile-details">
        <div className="card-header">
        <h5 className="mb-0">Cart Details</h5>
        </div>
        <div className="card-body">
        <div className="row row-gap-3">
        <div className="col-md-4 col-sm-6">
        <h6>Cart Number</h6>
        <p className="mb-0">{cart.cart_number}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Date & Time</h6>
        <p className="mb-0">{DateTime.get_date(cart.date_create)}{" "}{DateTime.get_time(cart.date_create)}</p>
        </div>
        <div className="col-md-4 col-sm-6">
        <h6>Grand Total</h6>
        <p className="mb-0">{Str.get_money(cart.grand_total)}</p>
        </div>
       </div>
        </div>
        </div>

        <div className="card profile-details">
        <div className="card-header">
        <h5 className="mb-0">Cart Items</h5>
        </div>
        <Table   allow_multiple={false} table={Portal_Table.CART} dataSource={cart_items} columns={cart_item_columns} Selection={false} />
        </div>

        <div className="card profile-details">
        <div className="card-header">
        <h5 className="mb-0">Cart Sub Items</h5>
        </div>
        <Table  allow_multiple={false} table={Portal_Table.CART} dataSource={cart_sub_items} columns={cart_sub_item_columns} Selection={false} />
        </div>
        </div>
        </div>
        </div>
        </div>
        {/* /Page Content */}
    </>
        );
};

export default Dashboard_Admin_Cart_Detail;
